export var REALTIME_WS_URL =
  "wss://ws.abriron.com/app/abriron-key?protocol=7&client=js&version=8.4.0";
